import { render } from "./pagination.vue?vue&type=template&id=5b4ba824&scoped=true"
import script from "./pagination.vue?vue&type=script&lang=js"
export * from "./pagination.vue?vue&type=script&lang=js"

import "./pagination.vue?vue&type=style&index=0&id=5b4ba824&scoped=true&lang=css"

import exportComponent from "/Users/alexey/Projects/gambody-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4ba824"]])

export default __exports__